import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './module.css';

const Label = ({ style, children, variant, updating, size }) => {
  return (
    <div
      style={style}
      styleName={classNames(
        'label',
        { [`label--${variant}`]: variant },
        { 'label--updating': updating },
        { [`label--${size}`]: size }
      )}
    >
      {children}
    </div>
  );
};

Label.propTypes = {
  children: PropTypes.string.isRequired,
  variant: PropTypes.string,
  style: PropTypes.object,
  updating: PropTypes.bool,
  size: PropTypes.string
};

Label.variants = {
  ADMIN: 'admin',
  'CLIENT-ONLY-OWNER': 'client-only-owner',
  DEVELOPMENT: 'development',
  GUEST: 'guest',
  PRODUCTION: 'production',
  STAGING: 'staging',
  STATUS_DANGER: 'status-danger',
  STATUS_DISABLED: 'status-disabled',
  STATUS_INFO: 'status-info',
  STATUS_SUCCESS: 'status-success',
  STATUS_WARNING: 'status-warning',
};

Label.defaultProps = {
  style: {},
  updating: false
};

export default Label;
